<template>
  <div class="high-risk">
    <div v-if="studentMedicalConditions && 0 < studentMedicalConditions.length">
      <v-alert
        color="#ff7f32"
        variant="outlined"
        type="warning"
        icon="mdi-exclamation-thick"
        class="mb-3"
      >
        <div>
          The selected students for this excursion have the following medical conditions:
          <br /><br />
          <ul class="mb-0 pl-3 high-risk-student-medical-conditions">
            <li
              v-for="(medical, medicalIndex) in studentMedicalConditions"
              :key="medicalIndex"
              :class="medical.supported ? 'high-risk-student-medical-supported' : ''"
            >
              {{ medical.name }}
            </li>
          </ul>
        </div>
      </v-alert>
      <v-alert color="#c80063" icon="mdi-alert-circle" variant="outlined" class="mb-3">
        <div>
          Only the highlighted medical conditions are supported and available in the High-Risk
          Medical Conditions drop-down. For medical conditions that are not supported, please follow
          your School's process for managing student high-risk medical conditions.
        </div>
      </v-alert>
    </div>
    <!-- eslint-disable-next-line vuejs-accessibility/form-control-has-label -->
    <select
      :id="objId"
      class="js-example-basic-single safe-select2-dropdown"
      name="selectControl"
      :disabled="!formControlEnabled"
    >
      <option value></option>
      <optgroup label="High-Risk Student Medical">
        <option
          v-for="(riskClass, cindex) in getRiskClasses()"
          :key="cindex"
          :value="riskClass.name"
          :disabled="riskClass.disabled"
          :title="riskClass.typeName"
        >
          {{ riskClass.name }}
        </option>
      </optgroup>
    </select>
    <risk-class
      :selectedrisk-classes="selectedRiskClasses"
      :form-control-enabled="formControlEnabled"
      :risk-type-label-displayed="false"
      :has-updated-medical-condition="hasUpdatedMedicalCondition"
      class="pt-2"
      @change-risk-category-done="changeRiskCategory"
      @has-updated-medical-condition="hasUpdatedMedicalCondition = true"
    ></risk-class>
    <cs-form-dialog
      id="dlg-update-medical-condition-warning"
      v-model="warningUpdateMedicalConditionDialogDisplayed"
      body-id="dlg-body-update-medical-condition-warning"
      heading="Update Student Medical Condition"
      :primary-action="{
        label: 'Confirm',
        eventName: 'primary-click'
      }"
      :secondary-action1="{
        label: 'Cancel',
        eventName: 'secondary1-click'
      }"
      @primary-click="updateRiskClass"
      @secondary1-click="warningUpdateMedicalConditionDialogDisplayed = false"
      @update:model-value="warningUpdateMedicalConditionDialogDisplayed = false"
    >
      <template #cs-form-dialog-content>
        This action may populate a new checklist. Do you want to continue?
      </template>
    </cs-form-dialog>
  </div>
</template>

<script>
// TODO: Use dependency injections instead of directly importing dependencies
import cloneDeep from 'lodash/cloneDeep';
import RiskClass from './RiskClass';

export default {
  name: 'HighRisk',

  components: {
    RiskClass
  },

  props: {
    name: {
      type: String,
      required: false,
      default: ''
    },
    id: {
      type: [String, Number],
      required: false,
      default: ''
    },
    formControlEnabled: {
      type: Boolean,
      required: true
    }
  },
  emits: ['changeRiskCategoryDone'],

  data() {
    return {
      warningUpdateMedicalConditionDialogDisplayed: false,
      selectedRiskClass: '',
      selectedRiskTypeName: '',
      hasUpdatedMedicalCondition: false
    };
  },

  computed: {
    placeholder() {
      return `Add ${this.name} Type`;
    },
    objId() {
      return `selectControl${this.id}`;
    },
    categoryName() {
      return this.name;
    },
    selectedRiskClasses() {
      return this.$store.getters['common/selectedClassByCategoryName'](this.name);
    },
    riskTypes() {
      return this.$store.getters['common/getListRiskTypesByCategoryName'](this.name);
    },
    studentMedicalConditions() {
      return this.$store.state.common.excursionDc.computed.studentMedicalConditions;
    }
  },

  mounted() {
    // eslint-disable-next-line no-undef
    const $selector = $(`#${this.objId}`);
    if (
      typeof $selector.data('select2') === 'undefined' &&
      $selector.next().hasClass('select2-container')
    ) {
      $selector.select2('destroy');
    }

    $selector.select2({
      matcher: this.$app.selectCustom.matchCustom,
      placeholder: this.placeholder
    });

    const that = this;

    $selector.on('select2:select', function (e) {
      that.selectedRiskClass = e.params.data.text?.trim();
      that.selectedRiskTypeName = e.params.data.title;
      // eslint-disable-next-line no-undef
      $(this).val('');

      if (that.selectedRiskClasses.length > 0 && !that.hasUpdatedMedicalCondition) {
        that.warningUpdateMedicalConditionDialogDisplayed = true;
        return;
      }
      that.updateRiskClass();
    });
  },

  updated() {
    // eslint-disable-next-line no-undef
    const $selector = $(`#${this.objId}`);
    if (
      typeof $selector.data('select2') !== 'undefined' &&
      $selector.next().hasClass('select2-container')
    ) {
      $selector.next().remove();
    }
    $selector.select2({
      matcher: this.$app.selectCustom.matchCustom,
      placeholder: this.placeholder
    });
  },

  unmounted() {
    // eslint-disable-next-line no-undef
    const $selector = $(`#${this.objId}`);
    $selector.select2('destroy');
  },

  methods: {
    changeRiskCategory() {
      this.$emit('changeRiskCategoryDone', this.name);
    },
    getRiskClasses() {
      const riskClasses = [];
      if (this.riskTypes && this.riskTypes.length > 0) {
        this.riskTypes.forEach((t) => {
          if (t.classes && t.classes.length > 0) {
            t.classes.forEach((c) => {
              const localC = cloneDeep(c);
              localC.typeName = t.name;
              riskClasses.push(localC);
            });
          }
        });
      }
      riskClasses.sort((a, b) => a.name.localeCompare(b.name));
      return riskClasses;
    },
    updateRiskClass() {
      // eslint-disable-next-line no-undef
      const $selector = $(`#${this.objId}`);
      $selector.trigger('change.select2');
      this.$store.dispatch('common/changeSelectRiskClass', {
        riskClass: {
          name: this.selectedRiskClass
        },
        riskTypeName: this.selectedRiskTypeName,
        riskCategory: {
          name: this.categoryName
        }
      });
      this.selectedRiskClass = '';
      this.selectedRiskTypeName = '';
      this.hasUpdatedMedicalCondition = true;
      this.warningUpdateMedicalConditionDialogDisplayed = false;
      this.$emit('changeRiskCategoryDone', this.name);
    }
  }
};
</script>

<style scoped>
.high-risk-student-medical-supported {
  color: #c80063;
}

:deep(.select2-container .select2-selection--single) {
  height: 42px;
}
</style>
